import React from 'react';

import { Typography } from '@mui/material';
import dayjs from 'dayjs';

import ContentCard from '../../../components/ContentCard';
import DataGrid from '../../../components/DataGrid';
import { ExamAttempt } from '../../../services/exams/types';

interface MarkedExamsCardProps {
  markedExams: ExamAttempt[],
}

const MarkedExamsCard = ({ markedExams }: MarkedExamsCardProps) => (
  <ContentCard variant="outlined" title="Marked Exams">
    {markedExams && markedExams.length > 0 ? (
      <>
        <Typography variant="caption">
          Staff members are paid for the exams they've done the initial submission for.
          <br />
          The dates are the <b>initial submission date</b> of the exams{' '}
          and subsequent edits / re-submissions are not accounted for.
        </Typography>
        <DataGrid
          rows={markedExams || []}
          initialState={{
            sorting: {
              sortModel: [{ field: 'creationDatetime', sort: 'desc' }],
            },
            pagination: { paginationModel: { pageSize: 5 } },
          }}
          pageSizeOptions={[5]}
          columns={[
            {
              field: 'creationDatetime',
              headerName: 'Date',
              width: 80,
              renderCell: (e: any) => dayjs(e.value).format('D-MMM'),
            },
            {
              field: 'studentName',
              headerName: 'Student',
              width: 200,
            },
            {
              field: 'examLabel',
              headerName: 'Exam',
              width: 240,
            },
          ]}
          getRowId={(e) => `${e.student}#${e.examId}#${e.attemptNumber}`}
          getRowHref={(e) => `/teacher/marking/${e.subject}/${e.examId}/${e.student}/${e.attemptNumber}`}
        />
      </>
    ) : (
      <Typography variant="caption">
        There are no exams marked by this staff member in the selected period.
      </Typography>
    )}
  </ContentCard>
);

export default MarkedExamsCard;
